import React from 'react';
import DateRangePicker from 'components/DateRangePicker/';
import PrevArrowIcon from 'assets/chevron-left';
import NextArrowIcon from 'assets/chevron-right';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from 'WindowDimensionProvider';
import { SkeletonLine } from 'components/theme/Skeleton/SkeletonLine';
import {
  ExperiencesAvailability,
  Title4,
  NextIconCalendar,
  PrevIconCalendar,
} from './styles';

interface RangeCalendarAvailabilityProps {
  endDateCalendar: Date;
  experience: { loading: boolean };
  handleOnDateChange: (date: Date) => void;
  isBookable: boolean;
  isDayHighlighted: (date: Date) => boolean;
  isRecurring: boolean;
  startDateCalendar: Date;
  onNextMonthClick: () => void;
  onPrevMonthClick: () => void;
}

const RangeCalendarAvailability = ({
  endDateCalendar,
  experience,
  handleOnDateChange,
  isBookable,
  isDayHighlighted,
  isRecurring,
  startDateCalendar,
  onNextMonthClick,
  onPrevMonthClick,
}: RangeCalendarAvailabilityProps) => {
  const isMobile = useIsMobile();
  const { t: translate } = useTranslation();

  if (!isBookable || !isRecurring || isMobile) return null;

  if (experience.loading) {
    return <SkeletonLine />;
  }

  return (
    <ExperiencesAvailability
      role="region"
      aria-label={translate('dateRangeSelector')}
    >
      <Title4
        as={'h3' as const}
        className="experience-view__experience-section-title"
      >
        {translate('avail')}
      </Title4>
      <DateRangePicker
        startDate={startDateCalendar}
        endDate={endDateCalendar}
        onChange={handleOnDateChange}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        noBorder
        isDayBlocked={(date: Date) => !isDayHighlighted(date)}
        isDayHighlighted={isDayHighlighted}
        isOutsideRange={(date: Date) => !isDayHighlighted(date)}
        onPrevMonthClick={onPrevMonthClick}
        onNextMonthClick={onNextMonthClick}
        navPrev={
          <PrevIconCalendar aria-label="Previous month" tabIndex={0}>
            <PrevArrowIcon color="var(--way-palette-black-100)" />
          </PrevIconCalendar>
        }
        navNext={
          <NextIconCalendar aria-label="Next month" tabIndex={0}>
            <NextArrowIcon color="var(--way-palette-black-100)" />
          </NextIconCalendar>
        }
      />
    </ExperiencesAvailability>
  );
};

export default RangeCalendarAvailability;
